var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"folder-frame"},[_c('Sidebar'),_c('router-view',{class:{'router-cnt':true, 'fix-scrollbar':true, 'router-cnt-collapsed':_vm.isCollapse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }